module.exports = __webpack_public_path__ + "assets/cad73dce9b8d584d77ec229bb1579cdd.svg";